export const splitCustomerName = (text: string): { lastName: string; firstName: string } => {
  const split = text.trim().split(' ')
  const lastName = split.length > 1 ? (split.length > 2 ? split.slice(0, -1).join(' ') : split[0]) : text
  const firstName = split.length > 1 ? (split.length > 2 ? split[split.length - 1] : split[1]) : ''
  return { lastName, firstName }
}
